var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 6.3195C6.33337 5.95131 6.63185 5.65283 7.00004 5.65283C7.36823 5.65283 7.66671 5.95131 7.66671 6.3195V10.3195C7.66671 10.6877 7.36823 10.9862 7.00004 10.9862C6.63185 10.9862 6.33337 10.6877 6.33337 10.3195V6.3195Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 3.03402C6.63185 3.03402 6.33337 3.33249 6.33337 3.70068C6.33337 4.06887 6.63185 4.36735 7.00004 4.36735C7.36823 4.36735 7.66671 4.06887 7.66671 3.70068C7.66671 3.33249 7.36823 3.03402 7.00004 3.03402Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 0.333252C3.31814 0.333252 0.333374 3.31802 0.333374 6.99992C0.333374 10.6818 3.31814 13.6666 7.00004 13.6666C10.6819 13.6666 13.6667 10.6818 13.6667 6.99992C13.6667 3.31802 10.6819 0.333252 7.00004 0.333252ZM1.66671 6.99992C1.66671 9.94544 4.05452 12.3333 7.00004 12.3333C9.94556 12.3333 12.3334 9.94544 12.3334 6.99992C12.3334 4.0544 9.94556 1.66659 7.00004 1.66659C4.05452 1.66659 1.66671 4.0544 1.66671 6.99992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8affa98b3ea8951c3029e6b6dbf7f69e.svg";
export { ForwardRef as ReactComponent };